@if ((multiImageDownloadActive$ | async) === false) {
  <div class="tile-favorite">
    <pc-shared-add-to-favorites-button
      (afterAdd)="onAfterAddToFavorites()"
      (beforeAdd)="$event.stopPropagation()"
      [config]="addToFavoritesButtonConfig"
    ></pc-shared-add-to-favorites-button>
  </div>
}

  <div class="tile-image-preview">
    <cat-lightbox-button [index]="index" [searchId]="searchId"></cat-lightbox-button>

    @if ((multiImageDownloadActive$ | async) === false) {
      <cat-image-preview-button [coreId]="coreId" [item]="item"></cat-image-preview-button>
    }
  </div>

<div class="tile-image-checkbox">
  <cat-multi-image-download-checkbox
    [coreId]="coreId"
    [image]="getImageUrl(item)"
    [recordId]="item.header.id"
    [title]="item.GulliverTabName"
    [type]="item.GulliverRecType"
  ></cat-multi-image-download-checkbox>
</div>

@if (isDropbox(item)) {
  <aipb-inside-loading [loading]="loading" diameter="20"></aipb-inside-loading>
}

<div class="tile-image" style.background-image="url({{ getImageUrl(item) }})"></div>

<div
  [innerHTML]="item.header.label.value"
  [ngClass]="['tile-label border-top', opened ? 'highlight' : '', active ? 'active' : '']"
  [title]="removeHighlight(item.header.label.value)"
></div>
